export default "__VITE_ASSET__BeELu7jm__"